import axios from "infra/http";
import { useQuery } from "react-query";
import { SimulacaoArrecadacaoResponse } from "./typings";

function useSimulacaoArrecadacao({
  mes,
  ano,
  arrecadacoesIds,
  mesConsumo,
}: {
  mes: string;
  ano: string;
  arrecadacoesIds?: string[];
  mesConsumo?: string;
}) {
  return useQuery(
    [`/v1/arrecadacao/${mes}/${ano}/simulacao`, arrecadacoesIds, mesConsumo],
    async () => {
      const res = await axios.get<SimulacaoArrecadacaoResponse>(
        `/v1/arrecadacao/${mes}/${ano}/simulacao`,
        {
          params: {
            arrecadacoesIds,
            mesConsumo,
          },
        }
      );

      return res.data;
    },
    {
      enabled: !!mes && !!ano,
    }
  );
}

export default useSimulacaoArrecadacao;
